module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-agriculture-icon-ff1779c26e8248e62f7849368fbc44ea.svg";